"use client";

import * as React from "react";
import { ChartBlock, LiquidityPie } from "@/components";
import { useTokenPairs } from "@/hooks/use-liquidity";
import { LIQUIDITY_CHARTS } from "@/constants";

export function TokenPairs() {
  const { data, isLoading } = useTokenPairs();
  const chartData = Array.isArray(data) ? data : [];

  return (
    <ChartBlock
      isSmall
      isRounded
      title="Token Pairs"
      isLoading={isLoading}
      className="overflow-visible"
      watermark={false}
    >
      <LiquidityPie
        data={chartData}
        colors={LIQUIDITY_CHARTS.TOKEN_PAIRS}
        isLoading={isLoading}
      />
    </ChartBlock>
  );
}
